import { Column } from 'app/design/primitives/box';
import { type useSharingPlaceMembers } from 'app/network/sharing-place';
import { View } from 'react-native';
import { type getTodayOpeningStatus } from 'app/lib/opening-hours';
import type { PlaceDetails } from './shared';
import { PlaceOpeningStatus } from './place-opening-status';
import { PlaceWebsite } from './place-website';
import { PlaceMembersSummary } from './place-members-summary';
import { PlaceActions } from './place-actions';

export function PlaceInfo({
  horizontalPadding,
  members,
  nextOpenDay,
  onFrequentingPress,
  onHelp,
  onItinerary,
  onOpenMembers,
  onOpenOpeningHours,
  onShare,
  openingStatus,
  placeDetails,
  variant,
  websiteUrl,
}: {
  horizontalPadding: number;
  members: NonNullable<ReturnType<typeof useSharingPlaceMembers>['data']>;
  nextOpenDay: string | undefined;
  onFrequentingPress: () => void;
  onHelp: () => void;
  onItinerary: () => void;
  onOpenMembers: () => void;
  onOpenOpeningHours: () => void;
  onShare: () => void;
  openingStatus: ReturnType<typeof getTodayOpeningStatus>;
  placeDetails: PlaceDetails | null | undefined;
  variant: React.ComponentProps<typeof PlaceActions>['variant'];
  websiteUrl?: string;
}) {
  if (!placeDetails) return null;
  return (
    <View>
      <Column gap="spacing.general.x3">
        <PlaceOpeningStatus
          nextOpenDay={nextOpenDay}
          onOpen={onOpenOpeningHours}
          openingStatus={openingStatus}
          placeDetails={placeDetails}
        />
        <Column gap="spacing.general.x1">
          <PlaceWebsite websiteUrl={websiteUrl} />
          <PlaceMembersSummary members={members} onOpen={onOpenMembers} />
        </Column>
      </Column>
      <PlaceActions
        horizontalPadding={horizontalPadding}
        onFrequentingPress={onFrequentingPress}
        onHelp={onHelp}
        onItinerary={onItinerary}
        onShare={onShare}
        variant={variant}
      />
    </View>
  );
}
